import * as $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
	$('.carousel .carousel__items').slick({
		arrows: true,
		arrowsPlacement: 'afterSlides',
		appendArrows: $('.carousel__custom-container .carousel__custom-arrows'),
		autoplay: true,
		adaptiveHeight: true,
		autoplaySpeed: 5000,
		useAutoplayToggleButton: false,
		centerMode: false,
		centerPadding: '0px',
		cssEase: 'ease-in-out',
		dots: true,
		appendDots: $('.carousel__custom-container .carousel__custom-dots'),
		draggable: true,
		fade: false,
		infinite: false,
		pauseOnHover: true,
		pauseOnFocus: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 500,
		initialSlide: 0,
		variableWidth: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: false
				}
			}
		]
	});
})
